import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

export const checkoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/checkout',
  component: CheckoutPage,
});

function CheckoutPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="w-full max-w-lg p-6">
        <h1 className="text-2xl font-bold mb-6">Checkout</h1>
        {/* TODO: Checkout form */}
        <p className="text-muted-foreground">Checkout page placeholder</p>
      </div>
    </div>
  );
}
